import { styled } from '@mui/material';
import Link from '@mui/material/Link';

export const LinkStyled = styled(Link)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
}));
